module.exports = __webpack_public_path__ + "img/precio_especial.62974a45.svg";